












































import Vue from 'vue';
import { mapActions } from 'vuex';
import { omit } from 'lodash';

import { BButton, BForm } from 'bootstrap-vue';

import LoadingSpinner from '@reciprocity/loading-spinner';

import FooterAppearance from './sections/FooterAppearance.vue';
import HeaderAppearance from './sections/HeaderAppearance.vue';
import InstantEmailNotifications from './sections/InstantEmailNotifications.vue';
import Logo from './sections/Logo.vue';
import Notifications from './sections/Notifications.vue';
import SenderDetails from './sections/SenderDetails.vue';

// Keys that shouldn't be sent to server when saving
const IGNORED_KEYS = ['previewUrl', 'logoUploadUrl', 'uploadEnabled', 'logo.default'];

export default Vue.extend({
  name: 'EmailSettingsPage',
  components: {
    BButton,
    BForm,
    FooterAppearance,
    HeaderAppearance,
    InstantEmailNotifications,
    LoadingSpinner,
    Logo,
    Notifications,
    SenderDetails,
  },
  data() {
    return {
      attemptedSave: <boolean>false,
      emailSettings: <object | null>null,
      loading: <boolean>true,
    };
  },
  async created() {
    this.setPageTitle({ title: 'Email Settings' });
    try {
      this.emailSettings = await this.request({ route: 'emailSettings' });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      setInstantEmails: 'setInstantEmails',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    async save() {
      this.attemptedSave = true;

      if ((this.$refs.form as HTMLFormElement).checkValidity() === false) {
        return;
      }

      await this.request({
        method: 'put',
        data: omit(this.emailSettings, IGNORED_KEYS),
        route: 'emailSettings',
      });

      // Update global settings:
      this.setInstantEmails({ instantEmailsOn: this.emailSettings.instantEmails });

      this.showAlert({
        type: 'success',
        message: 'Settings saved successfully',
      });
    },
  },
});
